/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Job_Match_DescInputs */

const en_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and track jobs from EU boards like Adzuna, Jooble, and Arbeitnow. AI scores how well you match each role.`)
};

const de_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche und verfolge Stellen von EU-Jobbörsen wie Adzuna, Jooble und Arbeitnow. KI bewertet, wie gut du zu jeder Rolle passt.`)
};

const fr_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche et suis les emplois sur des sites européens comme Adzuna, Jooble et Arbeitnow. L'IA évalue ton adéquation avec chaque poste.`)
};

const es_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busque y siga empleos de portales europeos como Adzuna, Jooble y Arbeitnow. La IA evalúa qué tan bien se ajusta a cada puesto.`)
};

const it_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca e monitora lavori da piattaforme UE come Adzuna, Jooble e Arbeitnow. L'AI valuta quanto corrisponde il tuo profilo a ogni ruolo.`)
};

const nl_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek en volg banen van EU-vacaturebanken zoals Adzuna, Jooble en Arbeitnow. AI beoordeelt hoe goed je bij elke rol past.`)
};

const pl_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukuj i śledź oferty z europejskich portali pracy jak Adzuna, Jooble i Arbeitnow. AI oceni, jak dobrze pasujesz do każdej roli.`)
};

const fi_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae ja seuraa työpaikkoja EU-sivustoilta kuten Adzuna, Jooble ja Arbeitnow. Tekoäly pisteyttää, kuinka hyvin sopivat jokaiseen tehtävään.`)
};

const da_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg og spor job fra EU-jobportaler som Adzuna, Jooble og Arbeitnow. AI scorer, hvor godt du matcher hver rolle.`)
};

const sv_landing_feature_job_match_desc = /** @type {(inputs: Landing_Feature_Job_Match_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök och spåra jobb från EU-jobbportaler som Adzuna, Jooble och Arbeitnow. AI betygsätter hur väl du matchar varje roll.`)
};

/**
* | output |
* | --- |
* | "Search and track jobs from EU boards like Adzuna, Jooble, and Arbeitnow. AI scores how well you match each role." |
*
* @param {Landing_Feature_Job_Match_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_job_match_desc = /** @type {((inputs?: Landing_Feature_Job_Match_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Job_Match_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_job_match_desc(inputs)
	if (locale === "fr") return fr_landing_feature_job_match_desc(inputs)
	if (locale === "es") return es_landing_feature_job_match_desc(inputs)
	if (locale === "it") return it_landing_feature_job_match_desc(inputs)
	if (locale === "nl") return nl_landing_feature_job_match_desc(inputs)
	if (locale === "pl") return pl_landing_feature_job_match_desc(inputs)
	if (locale === "fi") return fi_landing_feature_job_match_desc(inputs)
	if (locale === "da") return da_landing_feature_job_match_desc(inputs)
	if (locale === "sv") return sv_landing_feature_job_match_desc(inputs)
	return en_landing_feature_job_match_desc(inputs)
});